<template>
    <div class="px-2 pb-2 pt-1">
        <validation-observer #default="{ invalid }">
            <b-form @submit.prevent>
                <div class="mt-25">
                    <b-form-group label="دسته‌بندی" label-for="nameEnId">
                        <v-select v-model="form.ParentId" :searchable="false" dir="rtl" :options="categoriesData"
                            :reduce="(value) => value.id" label="name_Fa" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </div>
                <div class="mt-25">
                    <b-form-group label="نام" label-for="nameId">
                        <validation-provider #default="{ errors }" name="نام" rules="required">
                            <b-form-input v-model="form.Name_Fa"
                                :state="errors.length > 0 ? false : null"></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </div>
                <div class="mt-25">
                    <b-form-group label="نام انگلیسی" label-for="nameEnId">
                        <b-form-input v-model="form.Name_En"></b-form-input>
                    </b-form-group>
                </div>
                <div class="mt-25">
                    <b-form-group label="توضیحات" label-for="descriptionId">
                        <b-form-textarea rows="3" no-resize dir="rtl" class="text-primary-middle"
                            v-model="form.description"></b-form-textarea>
                    </b-form-group>
                </div>
                <div class="mt-2">
                    <b-button type="submit" variant="primary" @click="editCategories" :disabled="invalid || loading"
                        class="d-flex align-items-center justify-content-center w-100">
                        <span>ویرایش</span>
                        <b-spinner v-if="loading" class="ml-50" variant="white" small></b-spinner>
                    </b-button>
                </div>
            </b-form>
        </validation-observer>
    </div>
</template>


<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BFormRadio, BForm, BFormInput, BFormFile, BSpinner, BTable, BAvatar, BImg, BFormGroup, BFormTextarea } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import vSelect from 'vue-select';
import { storeService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BForm,
        BFormInput,
        BFormFile,
        BFormGroup,
        BSpinner,
        BTable,
        BAvatar,
        BFormTextarea,
        BFormRadio,
        BImg,
        ValidationProvider,
        ValidationObserver,
        vSelect
    },
    props: {
        categoriesData: {
            type: Array,
            default: () => [],
        },
        data: {
            type: Object,
            default: () => { },
        },
        index: {
            type: Number,
            default: 0,
        },
        idParent: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            required,
            storeId: null,
            file: null,
            loading: false,
            form: {
                Name_Fa: null,
                Name_En: null,
                description: null,
                DefaultCategoryIconId: null,
                CategoryIconImage: null,
                RemoveCurrentIcon: false,
                ParentId: null
            },
        }
    },
    methods: {
        editCategories() {
            this.loading = true;
            let formData = new FormData();
            if (!this.data.categoryIconImage && !this.form.CategoryIconImage) {
                this.form.RemoveCurrentIcon = true
                formData.append("RemoveCurrentIcon", this.form.RemoveCurrentIcon)
            }
            this.form.Name_Fa ? formData.append("Name_Fa", this.form.Name_Fa) : null
            this.form.Name_En ? formData.append("Name_En", this.form.Name_En) : null
            this.form.ParentId ? formData.append("ParentId", this.form.ParentId) : null
            this.form.description ? formData.append("description", this.form.description) : null
            this.form.DefaultCategoryIconId ? formData.append("DefaultCategoryIconId", this.form.DefaultCategoryIconId) : null
            this.form.CategoryIconImage ? formData.append("NewCategoryIconImage", this.form.CategoryIconImage, this.form.CategoryIconImage.name) : null
            storeService.editCategories(this.storeId, formData, this.data.id).then(({ data }) => {
                this.$emit('editSubCategories', this.index);
                this.$notif({ type: 'success', title: 'زیردسته با موفقیت ویرایش شد' });
            })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.data.name_Fa != 'null' ? this.form.Name_Fa = this.data.name_Fa : null
        this.data.parentId != 'null' ? this.form.ParentId = this.data.parentId : null
        this.data.name_En != 'null' ? this.form.Name_En = this.data.name_En : null
        this.data.description != 'null' ? this.form.description = this.data.description : null
        this.data.defaultCategoryIconId != 'null' ? this.form.DefaultCategoryIconId = this.data.defaultCategoryIconId : null
        this.storeId = localStorage.getItem("storeId")
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>